import React from 'react';

import { Helmet } from 'react-helmet-async';

import { GATSBY_SOURCE_CONTENTSTACK_PREFIX } from 'utils/constants';

interface BrowserPluginAttributes {
  uid: string;
  typename: string;
  locale: string;
}

interface ContentstackBrowserPluginProps {
  attributes?: BrowserPluginAttributes;
}

export const ContentstackBrowserPlugin: React.FC<ContentstackBrowserPluginProps> = ({ attributes }) => {
  if (!attributes) {
    return;
  }

  const { uid, typename, locale } = attributes;

  return (
    <Helmet
      bodyAttributes={{
        'data-pageref': uid,
        'data-contenttype': typename?.replace(GATSBY_SOURCE_CONTENTSTACK_PREFIX, ''),
        'data-locale': locale,
      }}
    />
  );
};
